import React from "react";
import { Headphones, MessageSquare, Clock, Mail } from "lucide-react";
import { Button } from "lib/ui";
import {
  AdminPageLayout,
  AdminHero,
  AdminStats,
  AdminFormPanel,
} from "../../../components/admin/AdminPageShell";

export default function Support() {
  return (
    <AdminPageLayout>
      <AdminHero
        icon={Headphones}
        badge="Customer care"
        title="Support"
        description="Central place for customer issues — connect your helpdesk or manage tickets manually."
      />

      <AdminStats
        items={[
          { label: "Open tickets", value: "—", icon: MessageSquare },
          { label: "Avg. response", value: "—", icon: Clock },
          { label: "Escalations", value: "—", icon: Headphones },
          { label: "Contact channel", value: "Email", icon: Mail },
        ]}
      />

      <div className="grid gap-6 lg:grid-cols-2">
        <AdminFormPanel
          title="Helpdesk integration"
          description="Wire your provider API to show live conversations here."
        >
          <p className="text-sm leading-relaxed text-slate-600">
            This screen is ready for Zendesk, Freshdesk, Intercom, or a custom
            ticketing API. Once connected, agents can reply to customers without
            leaving the admin console.
          </p>
          <ul className="mt-4 space-y-2 text-sm text-slate-600">
            <li className="flex gap-2">
              <span className="font-bold text-brand">1.</span>
              Add webhook URL in your helpdesk settings
            </li>
            <li className="flex gap-2">
              <span className="font-bold text-brand">2.</span>
              Map customer email to Tidyhub user profiles
            </li>
            <li className="flex gap-2">
              <span className="font-bold text-brand">3.</span>
              Enable push notifications for new tickets
            </li>
          </ul>
          <Button type="primary" className="mt-6" disabled>
            Connect provider (coming soon)
          </Button>
        </AdminFormPanel>

        <AdminFormPanel
          title="Quick actions"
          description="While integration is pending"
        >
          <div className="space-y-3">
            <a
              href="mailto:support@tidyhub.ae"
              className="flex items-center gap-3 rounded-xl border border-slate-200 bg-slate-50/80 px-4 py-3 text-sm font-semibold text-slate-800 transition hover:border-brand/30 hover:bg-brand-surface"
            >
              <Mail size={18} className="text-brand" />
              Email support@tidyhub.ae
            </a>
            <p className="text-xs text-slate-500">
              For urgent order issues, use the Orders page to look up the
              customer reference and update status directly.
            </p>
          </div>
        </AdminFormPanel>
      </div>
    </AdminPageLayout>
  );
}
